import script from "./PCSelectItemsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PCSelectItemsPopup.vue?vue&type=script&setup=true&lang=js"

import "./PCSelectItemsPopup.vue?vue&type=style&index=0&id=11d884f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11d884f4"]])

export default __exports__